import { Box, Grid } from "@mui/material"
import styled from 'styled-components';
import dayjs from "dayjs";
import CommonText from '../../components/common/typographies/CommonText'

function TicketDateItem({ t, date, index, isSelected, onClick }){
    return (
        <Container item xs container direction="column" justifyContent="center" alignItems="center" style={{ borderLeft: `${index === 0 ? 0 : 1}px solid rgba(233,233,233,0.3)`, backgroundColor: isSelected ? "#F44434" : "transparent" }} onClick={onClick}>
            <CommonText align="center" fontSize="18px" lFontSize="20px" lineHeight="24px" style={{ fontWeight: isSelected ? 600 : 0 }}>{dayjs(date).format(t("dateFormat"))}</CommonText>
            <CommonText align="center" fontSize="14px" lineHeight="16px" style={{ fontWeight: isSelected ? 600 : 0  }}>{dayjs(date).format("YYYY")}</CommonText>
        </Container>
    )
}

export default TicketDateItem

const Container = styled(Grid)`
    && {
        padding-top: 10px;
        padding-bottom: 10px;
        cursor: pointer;
    }
`;